﻿window.cObjetComEmailRecuMetier = function(objet) {
    var Me = this;
    this.data = objet.data;
    this.objet = objet;

    this.mGetTableUpdateLib = function () { return ["com_email_recu"] }

    this.mGetLibBase = function () { return "email reçu"; }
    this.mGetAttributBase = function () { return "l'" }
    this.mGetNewLib = function () { return "Nouvel email"; }
    this.mGetLib1 = function (option) {
        var txt = ""
        if (typeof objet.data != 'undefined') { txt = objet.data.objet }
        else {
          txt = "email reçu"
        }
        if (typeof option !='undefined' && typeof option.callBack != 'undefined') { option.callBack(txt) }
        else { return txt }
    }
    this.mGetLib2 = function () {
        return ""
    }

    this.mGetRadiusImage = function () { return "0" }
    this.mGetResume = function () {
        var txt = "";
        return txt;
    }

    this.mGetIcone = function (dataTemplate) {
        var $Icone = null
        if (typeof dataTemplate == 'undefined') { $Icone = $("<i class='fas fa-envelope-open'></i>"); }
        else {
            $Icone = $("<i class='fas fa-envelope-open' style='position:relative'></i>");
            var $ssIcone = $("<i class='fas' style='position:absolute;bottom:-2px;right:-2px;opacity:1;font-size:65%;color:" + theme.backgroundcolorAccent + "'/>")
            switch (dataTemplate.id_type_classement) {
                case "1": $ssIcone.addClass("fa-inbox"); break;
                case "2": $ssIcone.addClass("fa-archive"); break;
                case "3": $ssIcone.addClass("fa-shield"); break;
                case "4": $ssIcone.addClass("fa-person-circle-minus"); break;
                case "5": $ssIcone.addClass("fa-person-circle-exclamation"); break;
                case "6": $ssIcone.addClass("fa-person-walking-luggage"); break;
            }
            $ssIcone.appendTo($Icone)
        }
        $Icone.attr("title", "Email reçu")
        //$("<div/>").appendTo("body").dxCtrlTooltipHoverTarget({ target: $Icone, position: "bottom", contentTemplate: function (contentElement) { contentElement.text("Email reçu") } })
        return $Icone
    }

    //this.mActionSaveAfter = function () {
    //    Me.objet.bddRef.msgEmailNb.mGetData(true)
    //}

    this.mDisplayLstFile = function () {
        Me.objet.bddRef.mAjaxCall({
            command: "getlstfilejointemailrecu",
            id_com_email_recu: objet.data.id_com_email_recu
        }, function (data) {
            if (typeof data.lstFile == "undefined") data.lstFile = []
            if (data.lstFile.length > 0) $("<div/>").appendTo("body").dxCtrlViewer({
                bddCtrl: Me.objet.bddRef,
                value: data.lstFile,
                indexCourant: 0
            })
        })
    }

    this.contentTemplateGrid = function (contentElement, option) {
        contentElement.empty();

    }

    this.mGetItemTemplateHeight = function (type) {
        return ((type == "Détails") ? 73 : 35)
    }
    this.alignItemGrid = "right"
    this.mGetNomFromTemplate = function (dataTemplate) {
        return dataTemplate.objet
    }
    this.itemTemplateGrille = function (contentElement, dataTemplate, type, option) {

        //if (dataTemplate.nouveau == "1") {
        //    contentElement.parent().addClass("nouveauemail")
        //    contentElement.on("click", function (e) { contentElement.parent().removeClass("nouveauemail") })
        //}
        //contentElement.css("opacity", "0.8")
        var $Table = $("<table style='table-layout:fixed;width:100%;text-align:right;'/>").appendTo(contentElement)
        var $Tr = $("<tr/>").appendTo($Table)
        var $TdNew = $("<td rowspan='2' style='display:none;vertical-align:top;width:16px;'><i class='fas fa-circle-exclamation dx-theme-accent-as-text-color'</td>").appendTo($Tr)
        contentElement.closest(".divtemplate").css("opacity", "0.7")
        if (dataTemplate.nouveau == "1") {
            //contentElement.parent().addClass("nouveauemail")
            $TdNew.show()
            contentElement.closest(".divtemplate").css("opacity", "1")
            contentElement.closest(".divtemplate").css("box-shadow", "0 0 5px 0 #ffffff")
            if (objet.bddRef.theme.contains(".light")) {
                contentElement.closest(".divtemplate").css("box-shadow", "0 0 5px 0 #000000")
            }
            contentElement.on("click", function (e) {
                $TdNew.hide()
                contentElement.closest(".divtemplate").css("opacity", "0.7")
                contentElement.closest(".divtemplate").css("box-shadow", "")
            })
        }

        var $TdDest = $("<td style='width:20px;padding:0 1px;height:20px;'/>").appendTo($Tr)
        if (type == "Détails") {
            $TdDest.attr("rowspan", "2")
            $TdDest.css("width", "60px")
            $TdDest.css("height", "64px")
            $TdDest.css("padding", "5px")
        }
        if (dataTemplate.id_table_expediteur != null) {
            $("<div style='width:100%;height:100%;border-radius:50%;'/>").appendTo($TdDest).dxCtrlImgSimpleStrConUti({
                bddCtrl: objet.bddRef,
                idTable: dataTemplate.id_table_expediteur,
                id: dataTemplate.id_expediteur,
                text: dataTemplate.nom_usuel_expediteur
            })
            $TdDest.addClass("state-hover-border-shadow")
            if (objet.bddRef.utiCourant.id_utilisateur>99999) {
                $TdDest.addClass("state-hover-border-shadow")
                $TdDest.on("click", function (e) {
                    e.stopPropagation()
                    page.mAddPopupIdTableId(dataTemplate.id_table_expediteur, dataTemplate.id_expediteur)
                })
            }
        } else {
            $("<div style='width:100%;height:100%;border-radius:50%;opacity:0.5;'/>").appendTo($TdDest).dxCtrlImgSimpleStrConUti({
                bddCtrl: objet.bddRef,
                showText: false,
                icon1: "fas fa-circle-question",
                text: "Expéditeur inconnu"
            })
        }

        var $TdObjetBody = $("<td style='width:75%;overflow:hidden;text-overflow:ellipsis;padding:0 3px;'/>").appendTo($Tr)
        $TdObjetBody.css("white-space", "nowrap")
        var bodyTxt = $("<div/>").html(dataTemplate.body_txt).text().replace(/\u00A0/g, '')
        if (type == "Détails") {
            if (dataTemplate.objet == null || dataTemplate.objet.length == 0) { $TdObjetBody.html("&nbsp;") }
            else { $TdObjetBody.text(dataTemplate.objet.decoupe()) }
            $TdObjetBody.css("font-weight", "500")
            var $Tr2 = $("<tr/>").appendTo($Table)
            var $Td = $("<td style='width:100%;padding:0 3px;white-space:normal;font-style:italic;font-size:90%;line-height:1.3;opacity:0.7;padding-top:5px;' colspan='5'></td>").appendTo($Tr2)
            var $Div = $("<div class='ellipsismultiligne3'></div>").appendTo($Td)
            $Div.text(bodyTxt.decoupe())
        } else {
            bodyTxt = bodyTxt.substring(0, 300)
            var $B = $("<b style='font-weight:500;'/>").appendTo($TdObjetBody)
            $B.text(dataTemplate.objet)
            $("<span> &bull; <i style='opacity:0.7;'>" + bodyTxt + "</i></span>").appendTo($TdObjetBody)
        }

        var $TdICone = $("<td style='width:20px;padding:0 1px;height:1px;'/>").appendTo($Tr)
        $ImgIcone = $("<img style='width:18px;height:18px;display:inherit' title='Domaine de l&apos;expéditeur'/>").appendTo($TdICone)
        const faviconUrl = 'https://icons.duckduckgo.com/ip3/' + dataTemplate.email_expediteur.split("@")[1] + '.ico';
        $ImgIcone.attr('src', faviconUrl)
            .on('load', function () {
                $ImgIcone.show();
            })
            .on('error', function () {
                $ImgIcone.hide();
            });

        var $TdEmailExp = $("<td style='width:25%;overflow:hidden;text-overflow:ellipsis;padding:0 3px;font-size:90%;white-space:nowrap;'></td>").appendTo($Tr)
        var lib = ((typeof dataTemplate.nom_usuel_expediteur != 'undefined' && dataTemplate.nom_usuel_expediteur != null && dataTemplate.nom_usuel_expediteur.length > 0) ? dataTemplate.nom_usuel_expediteur + " [" + dataTemplate.email_expediteur + "]" : "[" + dataTemplate.email_expediteur + "]")
        $TdEmailExp.html("" + ((parseInt(dataTemplate.nbdest) > 1) ? "<span title='" + dataTemplate.nbdest + " destinataires'>(" + dataTemplate.nbdest + ")</span> " : "") + "<a href='javascript:void(0)' title='" + lib.replace(/'/g, "&#39;") + "'></a>")
        $TdEmailExp.find("a").text(lib)
        //$TdEmailExp.attr("title", lib)

        var $TdTaille = $("<td style='width:27px;font-size:90%;padding:0 3px;text-align:center;opacity:0.5;font-family:barlow condensed;'>" + dataTemplate.taille_octet.sizeFile(2) + "</td>").appendTo($Tr)

        var $TdFile = $("<td style='width:40px;text-align:center;padding:0 3px;' class='dx-theme-accent-as-text-color'></td>").appendTo($Tr)
        if (dataTemplate.nb_fichier_joint > 0) {
            $("<i class='fas fa-paperclip'></i><sup style='font-size:70%'>" + dataTemplate.nb_fichier_joint + "</sup>").appendTo($TdFile)
        }

        var $TdUti = $("<td style='width:20px;padding:0 1px;height:1px;'/>").appendTo($Tr)
        $("<div style='width:18px;height:18px;border-radius:50%;'/>").appendTo($TdUti).dxCtrlImgSimpleStrConUti({
            bddCtrl: objet.bddRef,
            idTable: objet.bddRef.getObjet("utilisateur").mGetTable().id_table,
            id: dataTemplate.id_utilisateur,
            text: objet.bddRef.getObjet("utilisateur", dataTemplate.id_utilisateur).mGetLib1()
        })


        //if (type == "Détails" && dataTemplate.nb_fichier_joint > 0) {
        //    contentElement.css("padding-bottom", "0px")
        //    objet.bddRef.mAjaxCall({
        //        command: "getlstfilejointemailrecu",
        //        id_com_email_recu: dataTemplate.id
        //    }, function (data) {
        //        if (typeof data.lstFile == 'undefined' || data.lstFile.length == 0) { }
        //        else {
        //            $("<div/>").appendTo(contentElement).dxCtrlFichier2Document({
        //                bddCtrl: objet.bddRef,
        //                dataSource: data.lstFile,
        //                readOnly: true
        //            })
        //        }
        //    })
        //}
    }
    this.itemTemplateGrillePlus = function (contentElement, dataPlus) {
        try {
            var $Span = $("<span style=''><i class='fas fa-envelope-open dx-theme-accent-as-text-color' style='padding-right:3px;'></i>" + dataPlus.date_reception.toDateIlya(true) + "</span>").appendTo(contentElement)
            $Span.attr("title", "Reçu le " + dataPlus.date_reception.toFrenchDateTime())

            //$("<span style='font-size:100%;' title='" + dataPlus.date_reception.toFrenchDateTime() + "'>" + dataPlus.date_reception.toDateIlya(true) + "</span> &bull; (" + dataPlus.email_destinataire + ")</span>").appendTo(contentElement)
            ////$("<span style='' title='" + dataPlus.date_reception.toFrenchDateTime() + "'>(" + dataPlus.email_destinataire + ") &bull; Reçu " + dataPlus.date_reception.toDateIlya(true) + "</span>").appendTo(contentElement)
        }
        catch (e) {
            var $Span = $("<span style=''>Reçu<br/>" + dataPlus.dcr.toDateIlya(true) + "</span>").appendTo(contentElement)
            $Span.attr("title", "Reçu le " + dataPlus.dcr.toFrenchDateTime())
            debugger
        }
    }

    this.itemTemplateCard = function (contentElement) {
        var $Table = $("<table style='width:100%'/>").appendTo(contentElement)
        var $Tr = $("<tr/>").appendTo($Table)
        var $Td = $("<td style='width:1px;vertical-align:top;'/>").appendTo($Tr)
        objet.mGetIcone().appendTo($Td)
        var $Td = $("<td style='width:100%'/>").appendTo($Tr)
        var txt = ""
        if (objet.data.objet != null && objet.data.objet.length > 0) txt += objet.data.objet
        if (objet.data.body_txt != null && objet.data.body_txt.length > 0) txt += ((txt.length > 0) ? " ⚉ " : "") + "<span style='opacity:0.5;'/>" + objet.data.body_txt + "</span>"
        $Td.html(txt)
    }

    this.isPopupFullScreen = true
    //this.mShowPopup = function (option) {
    //    if (typeof option == 'undefined') option = {}
    //    //if (typeof option.fullScreen == 'undefined') {

    //    //}
    //    option.fullScreen = true
    //    page.mAddPopup(objet.data, option)
    //}

    this.contentTemplatePopup = function (contentElement, option) {
        contentElement.empty();
        $("<div style='height:100%'/>").appendTo(contentElement).dxCtrlContentEmailRecu({
            bddCtrl: Me.objet.bddRef,
            optionPopup: option,
            data: objet.data
        })
    }

    this.mGetPopupPositionWidthHeight = function () {
        return {
            width: "550",
            maxWidth: "calc(100% - 60px)",
            height: "700",
            maxHeight: "calc(100% - 50px)",
            position: {
                my: "right bottom",
                at: "right bottom",
                of: "body",
                offset: { x: -50, y: -25 }
            }
        }
    }
    this.mGetDisplayInPopup = function (newValue) {
        if (typeof objet.bddRef.utiCourantParaJson["dataDisplayInPopup_" + objet.mGetTable().nom] == 'undefined') {
            objet.bddRef.utiCourantParaJson["dataDisplayInPopup_" + objet.mGetTable().nom] = true
        }
        if (typeof newValue != 'undefined') {
            objet.bddRef.utiCourantParaJson["dataDisplayInPopup_" + objet.mGetTable().nom] = newValue
            objet.bddRef.mSaveParaJsonUtilisateur();
        }
        return objet.bddRef.utiCourantParaJson["dataDisplayInPopup_" + objet.mGetTable().nom]
    }

}